<template>
  <div>
    <div class="d-flex flex-column flex-md-row justify-md-center align-md-center">
      <slot name="left" />
      <v-spacer />
      <div v-if="!hideOptionList" class="d-flex justify-center align-center">
        <div>{{ $t('paginate.show') }}</div>
        <v-select :items="optionList" v-model="option" required class="mx-2" style="width: 70px" />
        <div>{{ $t('paginate.entries') }}</div>
      </div>
      <v-spacer />
      <v-text-field v-model="search" prepend-icon="mdi-magnify" :label="$t('search')" single-line />
    </div>
    <div class="mb-5">
      <slot name="bot" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'TableHeader',
  props: {
    hideOptionList: {
      type: Boolean,
      value: false
    }
  },
  computed: {
    ...mapGetters({
      optionList: 'table/optionList'
    })
  },
  data: () => ({
    option: 10,
    search: ''
  }),
  watch: {
    option(val) {
      this.$store.commit('table/SET_DEFAULT_LIMIT', val);
      this.fetch();
    },
    search(val) {
      this.$store.commit('table/SET_DEFAULT_SEARCH', val);
      this.fetch();
    }
  },
  methods: {
    fetch: debounce(function() {
      this.$emit('fetch');
    })
  }
};
</script>
